/* HUSHLY — ouverture du menu mobile, panneau ancre sous le header */
(function(){
  function init(){
    var btn = document.querySelector('.hm-toggle');
    var panel = document.getElementById('hushly-menu');
    var veil = document.querySelector('.hm-veil');
    if (!btn || !panel || !veil || btn.dataset.hmReady === '1') return;
    btn.dataset.hmReady = '1';

    function place(){
      /* on s ancre sur la rangee du header, pas sur le bandeau d annonce */
      var h = document.querySelector('.header') || document.querySelector('.header-wrapper');
      var b = h ? h.getBoundingClientRect() : null;
      var top = b ? Math.max(b.bottom, 0) + 6 : 96;
      panel.style.setProperty('--hm-top', top + 'px');
      /* on cale le bord droit du panneau sur celui de la pastille d actions */
      /* on s'ancre sur la pastille entiere, pas sur le burger : le burger a change de
         place dans le DOM et son bord droit n'est plus celui du groupe */
      var ic = document.querySelector('.header .header__icons') || document.querySelector('.header .hm-toggle');
      var r = ic ? ic.getBoundingClientRect() : null;
      panel.style.setProperty('--hm-right', (r ? Math.max(innerWidth - r.right, 8) : 20) + 'px');
    }
    function open(){
      place();
      panel.hidden = false; veil.hidden = false;
      /* on force un recalcul plutot que requestAnimationFrame, qui ne se declenche pas dans un onglet masque */
      void panel.offsetHeight;
      panel.classList.add('is-on'); veil.classList.add('is-on');
      btn.setAttribute('aria-expanded','true');
      document.body.classList.add('hm-open');
    }
    function close(){
      panel.classList.remove('is-on'); veil.classList.remove('is-on');
      btn.setAttribute('aria-expanded','false');
      document.body.classList.remove('hm-open');
      setTimeout(function(){ panel.hidden = true; veil.hidden = true; }, 220);
    }
    btn.addEventListener('click', function(){
      btn.getAttribute('aria-expanded') === 'true' ? close() : open();
    });
    veil.addEventListener('click', close);
    addEventListener('keydown', function(e){ if (e.key === 'Escape' && !panel.hidden) close(); });
    addEventListener('resize', function(){ if (!panel.hidden) place(); });
    addEventListener('scroll', function(){ if (!panel.hidden) place(); }, {passive:true});
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* HUSHLY — le bandeau d annonce se replie des que la page defile */
(function(){
  var on=false;
  function tick(){
    var y=window.pageYOffset||document.documentElement.scrollTop||0;
    var want=y>8;
    if(want!==on){ on=want; document.body.classList.toggle('hg-scrolled',on); }
  }
  addEventListener('scroll',tick,{passive:true});
  addEventListener('resize',tick);
  if(document.readyState==='loading') addEventListener('DOMContentLoaded',tick,{once:true}); else tick();
})();
